import axios from 'axios';

const apiClient = axios.create({
  baseURL:       '/api',
  withCredentials: true,         // send httpOnly auth cookie
  headers: {
    'Content-Type': 'application/json',
  },
});

// Redirect to /login on 401
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;

/** Extract error message from an axios error */
export function getErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.error ?? error.message;
  }
  if (error instanceof Error) return error.message;
  return 'An unexpected error occurred';
}
